import { View, Button } from "@/components/ui";
import { PackageCard } from "@/components/shared/package-card";
import { PackagesFilter } from "../packages/packages-filter";
import { usePackagesByFiltersQuery } from "@/gqlhooks/packages/usePackagesByFiltersQuery";
import type { PackageStatusFilterItem } from "@/store/packages/usePackageState";
import { usePackageState } from "@/store/packages/usePackageState";
import { PackageStatusEnum } from "@/__generated__/graphql";
import { useState } from "react";
import { EmptyCard } from "@/components/shared/empty-card";
import NoPackages from "@/assets/images/3d-illus/no-packages.png";

export function PackageList() {
  const {
    data: { packageStatus },
    setPackageStatus,
  } = usePackageState();

  const {
    list: packageList,
    canLoadMore,
    loadMore,
    loading,
  } = usePackagesByFiltersQuery({
    status: packageStatus,
  });

  const [openActiveFilter, setOpenActiveFilter] = useState<boolean>(false);

  const packageStatusFilter: PackageStatusFilterItem[] = [
    {
      label: "All",
      value: "ALL",
    },
    {
      label: "Active",
      value: PackageStatusEnum.Active,
    },
    {
      label: "Inactive",
      value: PackageStatusEnum.Terminated,
    },
  ];

  function getStatusLabel(status: PackageStatusEnum | "ALL"): string {
    if (status === "ALL") {
      return "All";
    }

    switch (status) {
      case PackageStatusEnum.Active:
        return "Active";
      case PackageStatusEnum.Terminated:
        return "Inactive";
      default:
        return "All";
    }
  }
  return (
    <View className="flex flex-col gap-4">
      <PackagesFilter
        setOpenActiveFilter={setOpenActiveFilter}
        setPackageStatus={setPackageStatus}
        statusLabel={getStatusLabel(packageStatus)}
        openActiveFilter={openActiveFilter}
        packageStatusFilter={packageStatusFilter}
        packageStatus={packageStatus}
      />
      {!!packageList.length && (
        <>
          <View className="flex flex-col gap-4 pb-4">
            {packageList.map((item) => (
              <PackageCard key={item.id} item={item} />
            ))}
            {canLoadMore && (
              <View className="flex flex-col items-center">
                <Button
                  variant="tertiary"
                  color="CTA2"
                  fullWidth="full"
                  loading={loading}
                  onClick={loadMore}
                  children="Load more"
                />
              </View>
            )}
          </View>
        </>
      )}

      {!packageList.length && (
        <EmptyCard title="You don't have any Packages" src={NoPackages} />
      )}
    </View>
  );
}
